import { loyaltyCompletedEarningRuleBaseSchema } from "@redotech/redo-customer-common/customer";
import * as z from "zod";

const loyaltyCustomerSchema = z.object({
  _id: z.string(),
  currentPoints: z.number(),
  currentMoney: z.number(),
  pointsEarned: z.number(),
  moneySpent: z.number(),
  pointsSpent: z.number(),
  earningRuleConditions: z.object({
    hasReviewed: z.boolean(),
    hasBirthday: z.boolean(),
  }),
  completedEarningRules: z.array(loyaltyCompletedEarningRuleBaseSchema),
});

export const getLoyaltyCustomer = {
  name: "getLoyaltyCustomer" as const,
  input: z.object({
    customerIdentifier: z.union([
      z.object({ shopifyCustomerId: z.string() }),
      z.object({ email: z.string() }),
      z.object({ phoneNumber: z.string() }),
    ]),
  }),
  output: z.object({ loyaltyCustomer: loyaltyCustomerSchema.nullable() }),
};
